export class ScreenSize {
    /** < 600 */
    xs: boolean;
    /**  > 600  < 1280 */
    md: boolean;
    /** > 1280 */
    lg: boolean;
}